import { z } from 'zod';
export const withdrawUSDCInputSchema = z.object({
    address: z.string().min(1, 'Address is required'),
    amountInCents: z.number().int().positive('Amount must be positive'),
});
export const withdrawUSDCOutputSchema = z.object({
    success: z.boolean(),
    payoutId: z.string(),
    amount: z.number(),
    address: z.string(),
    status: z.string(),
    transactionId: z.string(),
});
